import {
  getNewDraftById,
  NewGetDraftByIdResponse,
} from '@app/store/transport-layer/document/drafts';
import { copyDraftRequesterAttachments } from '@app/store/transport-layer/document/drafts/attachments/copy';

export async function getEmbeddedDraft(draftId: string): Promise<NewGetDraftByIdResponse> {
  const [draftData, copiedAttachments] = await Promise.all([
    getNewDraftById(draftId),
    copyDraftRequesterAttachments(draftId),
  ]);
  draftData.attachments = copiedAttachments.attachments;
  return draftData;
}
